import { useQuery } from '@tanstack/react-query';
import { getAreaLocationDetails } from '../services';

/**
 * Fetch administrative location details (e.g. states/provinces) for a specified country code.
 */
export function useCountryStateDetails(country: string | null) {
  return useQuery({
    queryKey: ['getAreaLocationDetails', country],
    queryFn: () => getAreaLocationDetails(country),
    staleTime: 60000,
    enabled: !!country,
  });
}
